import React, { useState } from 'react';

export default function Accordion({title, body}) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div>
            <div onClick={() => setIsOpen(!isOpen)}
                className='cursor-pointer'>
                <div className="w-full border-2 rounded-xl p-4 flex justify-between bg-[#D1ECF2] mb-1 hover:bg-[#A4D8E1] transition-colors">
                    <h2 className="font-bold">{title}</h2>
                    <div className='text-lg'>{isOpen ? '-' : '+'}</div>
                </div>
                {isOpen && (<div className='rounded-xl border text-md p-5 bg-white'>
                    {body}
                </div>)}
            </div>
        </div>
    );
}